import React, { useState, useEffect } from 'react';
import { hostname } from '../../constants';
import Page from '../../layouts/Page';
import Grid from '../../components/Grid';
import Product from '../../components/Product';
import styles from './styles.module.sass';

interface RawProduct {
  id: string;
  acf: {
    intro?: string;
    image_1: { url: string };
    price?: number;
    in_stock?: boolean;
    purchase_from_hotel?: boolean;
    buy_link?: string;
  };
  content: { rendered: string };
  title: { rendered: string };
}

interface ProductItem {
  id: string;
  acf: {
    intro?: string;
    image_1: string;
    price?: number;
    in_stock?: boolean;
    purchase_from_hotel?: boolean;
    buy_link?: string;
  };
  content: { rendered: string };
  title: { rendered: string };
}

const Shop: React.FC = () => {
  const [data, setData] = useState<ProductItem[]>([]);

  useEffect(() => {
    fetch(`${hostname}/wp-json/wp/v2/product?per_page=100`)
      .then(res => res.json())
      .then((items: RawProduct[]) => {
        const mapped: ProductItem[] = items.map(item => ({
          id: item.id.toString(),
          acf: {
            intro: item.acf?.intro,
            image_1: item.acf?.image_1.url,
            price: item.acf?.price,
            in_stock: item.acf?.in_stock,
            purchase_from_hotel: item.acf?.purchase_from_hotel,
            buy_link: item.acf?.buy_link,
          },
          content: item.content,
          title: item.title,
        }));
        setData(mapped);
      })
      .catch(console.error);
  }, []);

  if (data.length === 0) return null;

  return (
    <Page className={styles.base}>
      <Grid data={data} tile={Product as any} />
    </Page>
  );
};

export default Shop;
